import type React from 'react';
import type { CSSProperties } from 'react';

import classNames from 'classnames';

import getSvgSpritePath from '../utils/get_svg_sprite_path';
import ICONS, { type IconType } from './constants';

import mixins from '../styles/core/mixins.module.css';

type Props = React.SVGProps<SVGSVGElement> & {
  className?: string;
  textAlign?: boolean;
  width?: number;
  height?: number;
  size?: number;
  icon?: IconType;
  fill?: string;
  style?: CSSProperties;
  'data-menu'?: string;
};

const Icon: React.FunctionComponent<Props> = ({
  textAlign,
  className,
  size = 18,
  icon,
  width,
  height,
  fill = 'currentColor',
  style,
  'data-menu': dataMenu,
  ...restProps
}) => (
  <svg
    fill={fill}
    style={style}
    data-menu={dataMenu}
    {...{ ...restProps, icon }}
    className={classNames(className, textAlign && mixins.text_align_icon)}
    width={width || size}
    height={height || size}
  >
    <use href={`${getSvgSpritePath()}#${icon}`} />
  </svg>
);

export { ICONS };
export default Icon;
